import { render } from "./ServiceOptionsView.vue?vue&type=template&id=2888261d&scoped=true"
import script from "./ServiceOptionsView.vue?vue&type=script&lang=js"
export * from "./ServiceOptionsView.vue?vue&type=script&lang=js"

import "./ServiceOptionsView.vue?vue&type=style&index=0&id=2888261d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2888261d"]])

export default __exports__